<script>
import { nextTick } from 'vue';
import { updateASmallTask, deleteASmallTask } from '@/services/SmallTasksServices';

export default {
  props: [ 'propTask', ],
  data() {
    return {
      smallTask: null,
      formInputSmallTask: '',
    };
  },
  computed: {
    uId() { return this.$store.getters['uId']; },
    token() { return this.$store.getters['token']; },
    today() { return this.$store.getters['today']; },
    todayActual() { return this.$store.getters['todayActual']; },
  },
  methods: {
    async stackSmallTask(newStatus) {
      const updatedTask = {
        task: this.smallTask.task,
        stacked: newStatus,
        dateCreated: this.smallTask.dateCreated,
        datedUpdated: this.todayActual,
      };

      const successfullyStackedSmallTask = await updateASmallTask(this.uId, this.token, this.today, this.smallTask.id, updatedTask);
      if (successfullyStackedSmallTask) {
        let t = {...updatedTask};
        t.id = this.smallTask.id;
        this.smallTask = t;
      }
    },

    clickEditSmallTask() {
      this.smallTask.task = '';
    },

    async updateTask() {
      const taskId = this.smallTask.id;
      const updatedTask = {
        task: this.formInputSmallTask.trim(),
        stacked: this.smallTask.stacked,
        dateCreated: this.smallTask.dateCreated,
        datedUpdated: this.todayActual,
      };

      const successfullyStackedSmallTask = await updateASmallTask(this.uId, this.token, this.today, taskId, updatedTask);
      if (successfullyStackedSmallTask) {
        let t = {...updatedTask};
        t.id = taskId;
        this.smallTask = t;
        this.formInputSmallTask = t.task;
      }
    },

    async deleteSmallTask() {
      await deleteASmallTask(this.uId, this.token, this.today, this.smallTask.id);
      await nextTick();
      window.location.reload();
    },
  },
  created() {
    this.smallTask = this.propTask ? { ...this.propTask } : {};
    this.formInputSmallTask = this.propTask.task ? this.propTask.task : '';
  },
};
</script>

<template>

  <div v-if="smallTask.task" class="d-flex my-3">

    <v-icon v-if="!!smallTask.stacked"
      class="mr-2"
      @click.prevent="stackSmallTask(false)"
    >mdi-checkbox-marked-outline</v-icon>
    <v-icon v-else
      class="mr-2"
      @click.prevent="stackSmallTask(true)"
    >mdi-checkbox-blank-outline</v-icon>

    <div class="w-100 d-flex justify-space-between align-start">
      <p class="one-small-task" :class="smallTask.stacked ? 'text-decoration-line-through' : ''">
        {{ smallTask.task }}
      </p>
      <p class="click-edit-small-task ms-2 text-right text-body-2 text-red-lighten-3"
         @click.prevent="clickEditSmallTask"
      ><i>Edit</i></p>
    </div>

  </div>

  <div v-else> <!-- edit smallTask.task -->
    <v-textarea v-model="formInputSmallTask"
                variant="outlined"
                rows="1"
                auto-grow
    ></v-textarea>
    <div
      class="mb-6 d-flex justify-end"
      :class="formInputSmallTask ? 'justify-space-between' : 'justify-end'"
      style="margin-top: -16px;"
    >
      <v-btn v-if="formInputSmallTask" @click.prevent="deleteSmallTask"
             class="text-capitalize"
             density="compact"
             color="px-2 red-lighten-3"
      >
        Delete Task
      </v-btn>
      <v-btn
        @click.prevent="updateTask"
        class="px-2 text-capitalize"
        density="compact"
        :class="formInputSmallTask ? 'bg-green-lighten-3' : ''"
        :disabled="!formInputSmallTask"
      >
        Update Small Task
      </v-btn>
    </div>
  </div>

</template>

<style scoped lang="scss">
  .one-small-task { white-space: pre-line; }
  .click-edit-small-task {
    &:hover { cursor: pointer; }
  }
</style>
